import './Katalog.css';
import { Link } from 'react-router-dom';
import SeoHead from '../seo/SeoHead';
import MobileBottomNav from '../components/MobileBottomNav';

const products = [
  {
    name: 'Letáky',
    description: 'Tisk kvalitních letáků na různé typy papírů s precizním barevným podáním pro vaši kampaň.',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAIohu7_8_NcjSRokxVtFO_bwcZfh36S749lw68MuavB0-jNqpirNJGzK3ASBDyBk-4BurJ4xNR44vNaFBUe3dFAGwFRxBn39HMEw6oed2QO2GWCXyOLQK71gh8r_d5qOyE9pugxkZ3sh0HmljrB8_RIKS4NVxQ0r6kOLMRSkaG5IN8sTpTJfyYkxzjPGf7dzGROynuKrwF-8-zRvRCjjE21BOwpn50j0hEXfeSEVCKVrwuUih76vWQL2l4jgwgXirAkXl0oq9vjLc',
    alt: 'minimalist collection of high-quality printed flyers stacked neatly on a white architect desk with soft natural side lighting',
    detailPath: '/letaky',
  },
  {
    name: 'Katalogy / brožury',
    description: 'Tisk brožur s vazbou V1, V2 nebo V4. Reprezentativní materiály pro vaši prezentaci.',
    detailPath: '/katalogy',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAP0nXP4HEcJxsrz3Z-RGp4CI2ddudyzMLZjDtWf03FUb2y33U-fx3sXJm0dFvjY8aOcj8OUppFA7bp1fGdXIc-mIlJI9r41IwhWeLh9MGyWtAa_cXnFqCwTls2DVQEVxIfBldMW9PRqbPd0kg49zEJG4aXBI_OV-aN4ppUkOQAiuYJaLkm0CaM2j0YWeJyMwfy6EHYkAMDKMQhUEtRBffnN7B_Q44SImnZ0cMnh3odcqnjUHIA8Ag_J1ujUktN6FykEHvEKZzDUcY',
    alt: 'high-end editorial design brochure open on a marble table showing minimalist photography and clean typography spreads',
  },
  {
    name: 'Obaly',
    description: 'Tisk obalů od malých krabiček po luxusní dárková balení na míru vašim produktům.',
    detailPath: '/obaly',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuB5hq8n3HfrgL-ucvkms6qVzwo1Usqe26zkP2IiRfxwRMc4REDbjDQ5QIza_suDn_n8ipQB8g9eOWx9PiYQqjtYWntGughE-lZyOsqyra7g5h3pAKPednvQ1epWIPGDHGWs6XQXNKAk2m48oH5hsbd_xSfOkTQKIAkh5OQKWkZwQBdjQHJxxoEm0VCFD-mUDLkzUBNu4BzzzjS_SAPx3nK9U2M0QuRB6DGONLOxMNV7RrzkTnDgwHKhByV4TvrALZ6PBp64f1safQM',
    alt: 'collection of premium matte black packaging boxes with silver foil stamping arranged in a geometric composition',
  },
  {
    name: 'Slohy / firemní složky',
    description: 'Formáty A4 a A5 s výsekem pro vizitku. Nezbytnost pro každé obchodní jednání.',
    detailPath: '/slozky',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBAvIG91yBGxzRHkZBUZsn_TiX6stVI7CNz1kM562o3h4UkorUbDTHJhOPpGBpvAMqcIFvdmBmheCZ8Y7uHNj9QWaBYMkcbLRUA8oKyi2zgg6vn9OR4T0bwSJ73XKNQI5nZEUAqvIiHf8kcAXbsr0U6EDxfZL43-uyonudSNsF9KpGD8egAZPZ6e2Wouvt6nVG_a3QGPtZvRFM866i4Mi2SZyvseFuu5s8ZSvg0UQEPsaeXSAF4YP1S7hiUxeWWQsL8a7u9UT1KIOc',
    alt: 'professional corporate folders with pocket and business card slot in deep blue with architectural logo',
  },
  {
    name: 'Plakáty',
    description: 'Od plakátů A3 až po plakáty XXL. Velkoplošný tisk s maximálním detailem barev.',
    detailPath: '/plakaty',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAa5p3j5sptDkJiM_Np9Ctg1cRHwPoE3oEaDEiinsvI_J1WwpAUxdgqBqfCOXkrA3hClZ9fRacGD--kKokRcspf6zt5FWf6o_YP7kP5WP5PD7wfdyYzC73Arqea7lX1_FnKv5YJeW39tPYKPCD2LCKo4vEVEWAdn4sQKIVqe5HOqRFW1Z6fBqyc_Bh_ASHhrP5nzHsqkoUdJIDLl4Fq3B51G1UW_vSSswYL1Xf1lcz0d_WHoGbKdVf4C21C3LKfB9d5ecsAa30PuOU',
    alt: 'large format art poster hanging in a concrete gallery space with dramatic overhead lighting and minimalist frame',
  },
  {
    name: 'Etikety',
    description: 'Tisk plastových i papírových etiket v rolích i arších pro potraviny i průmysl.',
    detailPath: '/etikety',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuB3A8uTU3GYCY4F8BvM9X0CCqAtOQt_3RyPIOyyXHzs-z0KsYCHRokgsEErl7o0se9Zuf0CwGMNBNaX_NxOqRID8PZvwswdorF8moUgEIzJknoetkUJOKwLaAQ6u-d5y5KNUlSJ8t72jhkCwmwBXZu9FRq9CwpWTHND3Vl3kpnBNIzzLG-YpDoPunLT5YcH_R4swQ-UMayekB68HD1ge7Yz7ApQxTiX-lyKo8zNWcA7rmSw7OSvUaQ4P2BEwKvQqoTZ4Ql2TL1SLx4',
    alt: 'roll of custom printed wine labels on textured paper with gold foil accents on a dark background',
  },
  {
    name: 'Bannery',
    description: 'Maximálně kvalitní UV tisk na plachtovinu s dlouhou životností a odolností.',
    detailPath: '/bannery',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAVPPvwBAGj361ggz_x_8_7V8danEh6p20mzctRqFPc4gSuln2Wzx2KZ-v9zdg-Ifaf2fXqED970crYZlJSpFNXdO4A_Hc2P2aoK1JJJOIIe-d4erEQT6QT_nb-pNxlSY5XBeo8shCfBDwHMUgWSoRJgLrdBbmd-w6ySi0iRLkC78AJEvkywUSESHyQkeXJPor4HvMAOsux8JkWXsklyvREhYJHU2ZTOlnGHQl8Q4f7M6LmF9SRb0RdJHkOYtA9Sb-Ppsx9N2FVIt4',
    alt: 'outdoor vinyl banner hanging from a modern building with high-contrast architectural graphics and metallic grommets',
  },
  {
    name: 'Bloky',
    description: 'Lepené potištěné bloky pro vaše poznámky. Skvělý reklamní předmět pro klienty.',
    detailPath: '/bloky',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDqOve26pH-cBvLcau1CsBepoeNkbeNtB3UILJTb3RDTuBJR6-RgEmC-91jRLnXWEkK_spxyyyD1UyQ5aoS6RqF0VnbgbaIQUkoybXKa4QOseb3GxSP-dsPVFge8zFSAeH7quxQckyy8Dc33qCviBXVOu-0C_nE_ieZM9lwQ61o5H6dKpInFqrw6JN_kf7O8hWdu1NOHmlueLaUvtI0ibiXvl2CwCIAo9svj8Hg-BxHKSK9N2cThArZRpwMYlvd5OHWOkjURQBFC9E',
    alt: 'stack of minimalist custom printed notebooks with clean white covers and blue spine detail on a light wood surface',
  },
  {
    name: 'Knihy',
    description: 'Tisk knih s tvrdými deskami i paperbacky. Kvalitní vazba a špičkový papír.',
    detailPath: '/knihy',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDJjMdlnPPsHEo__OKHKHrj8wdc0hcPcJWufk3BhLIgxgwg9EHCcvF4vdwWv4qvMO_MiyhKA_hif914Wj-1TRWMRyiVOMvc7CB9qEBbNo0LRfMCPW4r6W3DRU8juLn_FlzzZkmyRQCYUwj1A4PpSmI7rI5-xxs9ptgg7l1JcediDLZm793DDTUFriuMXytT7EKSs2fR-0Eu8BNGe0fZPyatwtJihK0HFFEqCvsgP9LFziYe6uUG2AR3yBtZdJZzG-NC3MUtjwck_As',
    alt: 'hardcover art book with a dust jacket featuring abstract geometric patterns on a library shelf',
  },
  {
    name: 'Lepící pásky',
    description: 'Papírové kravatové samolepící pásky s vlastním logem pro ekologické balení.',
    detailPath: '/lepici-pasky',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuA8Q-hISqWHHZnOJ2idMWyIeGkdjHW3ACS_fAkrNYP6qneIWDGwOrlNUnlO60eMt99kj54dFOY1vstuXlilhMSEK2qlL8_zqfixG9PG0P5G97-5USloMv0Vd3qYCkECqj5chdAqH0fBr5cUzoeouKpnyMN828oO2DI6trXua44LUwUoMETErqIQ6g6UXLVQPrSWaefa1PbQVVO5iaFRGysWSXkGdkfnFIIGxxnWapufuTdcsmK1ro6JgtbrQC5oBeaSJ-O-GB0GPB0',
    alt: 'rolls of custom printed paper adhesive tape with corporate branding in minimalist architectural style',
  },
  {
    name: 'Tašky s potiskem',
    description: 'Velký výběr papírových tašek s potiskem. Od kraftových po luxusní laminované.',
    detailPath: '/tasky',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuB_Xx-P_UN4UZ7OCV7xyNlSbkNzJqYM3k_FxI9KkxD47qlbpsuxmggazrnkB8hMKidv0ARJjMR-7gKtJiwywo1uhcPbJjRDagcevLa9qeBZHMHwocBsXV9434K_xcWoG8hlwBJRPmUSOS_Yb9puFkXaJzsaBw9N5cjg7pL2k1flIBYty-sZsUAczKCL7oBEq_iIV40_D5xTdEypcmgoENWGSlKgeFlHkhzhOTxHl8aExUIDMextLdTe9iaI5U3oLjBQo6YgkDYZyx0',
    alt: 'premium white paper shopping bag with black braided handles and minimalist logo debossing',
  },
  {
    name: 'PVC samolepky',
    description: 'Plastové samolepky pro venkovní použití. Odolné proti vodě a slunečnímu záření.',
    detailPath: '/pvc-samolepky',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuA2qpldEoa8YYOh4St7tCN6gkHX_cpVq4gvmEVuSrBFCmmO3e5iOjtJCmIixN6m8A2RzVn5GML4MdBvAsaF5yqQ9L1LYPeIfzOQwaoBP0nRP5A-SJS5anmBAH3opJAZX3eoNu0GeFtixqJDpGxrTvWJ_SM6kFAf8Sp3UjCUiMZ8Ji8bRtrDHucdn9qyefMP8aHUWBMyfUOVAJcUayfnt89usCVlFUl_K70HZcaQHLsjSttzqDdG7GQnv32wbHTtIWvrBsssxTU6UfM',
    alt: 'geometric cut vinyl stickers on a industrial concrete background with sharp shadows and vivid colors',
  },
  {
    name: 'Obálky',
    description: 'Klasické poštovní i dárkové obálky s vlastním přítiskem pro firemní korespondenci.',
    detailPath: '/obalky',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuA5T_R5UmL3Zo3T0_x7-tw-2egM4b4ZHeEeufd4pAtFWBsW2_vT4NZ-NyvcOeqG_1UdcgY633h62nbmjGZqKIX2KOl79Lc6Pmov1zhBKS5VhQrBlXxQF_AP30Puk6tKupjLlEFUIlFR6Z4Y0gARx8GfhIVl3Ciq1kFuwxvUljT_V07WmL1-HmVxaWU-IPXYZFwnFDEOt5KyAEcE90kVwBKs8GNnkIl35QoXtALryBwpve-QL2LqzY7W6LvG0mnOtIaDXQ7OZfoQAvs',
    alt: 'selection of high-quality corporate envelopes in grey and cobalt blue tones on a clean studio background',
  },
  {
    name: 'Reklamní puzzle',
    description: 'Různé velikosti složených puzzle. Originální dárek s vaší vlastní grafikou.',
    detailPath: '/reklamni-puzzle',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDb8xoooNHQFF56vNCJ1lrv9zzPjTuwvfgZgv995Qe5OU1bMzomjnXdHKINJH64k3UDEcO-N_0yH4W4227k_p7qQNS3D7i_8GNQ7K98H21hGuc3Drn3UXq3bgv52oXJG2TKTzQ-6JK5txZHkYTDjiBhuWlZKPB6PxD9Kx9jxzhwG7ayOmRoEoFui49oBo7NgGcmAdEulTE4r0B56ZaTVBk-kKR_5n-cuZVDzWDHcl2j-WpyIYwyBS3dbYz-P0kCNyDWzjXBqdgmo9I',
    alt: 'custom printed puzzle with architectural photography partially assembled on a dark slate surface',
  },
  {
    name: 'Textil s potiskem',
    detailPath: '/textil',
    description: 'Kvalitní trika s potiskem, mikiny, kšiltovky. Odolný tisk a moderní střihy.',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDD6S614s4cTZD4Ph7u_TaxK6O51MkeGWwZaxOqu5EdIRZSkEtRJ_BNOoORsKdgxb8T5aNzOZuYnoR8ym7CwrLbRkDIC2O6U90wzZBqGkjRzYHhh5lhY45ExVuztxhS7TOdn95Juj59rV-gx2s5wd3xDM81CWTiDIYTg6HOjFAk8Feq8Ws3v4VMollsAA_zC45UfWuTrNf4ukjLvJZlxJLuLQVvDrSFvjVt7Zm6U5wTgMeh7vxinVEcsLF1FNTJWmHhXCFTigTm6ac',
    alt: 'clean white t-shirt with a small architectural logo print displayed on a minimal wall hanger',
  },
  {
    name: 'Samolepící bločky',
    detailPath: '/samolepici-blocky',
    description: 'Klasické post-it bločky v různých rozměrech. Praktický pomocník s vaším logem.',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuA4EJR07TcWzUwX-zf-A58jaY5mTJqs2dPnkpoTv4e-r2Eh-CtRnZ9x22AB1aGTb3f3TU5zHM0XlPQkYLRoIGJ_nJDKMo5luqPOMNOd2ebEGeoenvbO6o8MEG9LJzcFeA3czvEzUWUog42P5MIRJqiNyCTiXwmTOLCsJ6zMaJ5kNWxEf4tDBkDxUqbijjLkpk-EGZOmZCS30lr4mquA6koIg3k752Q2W2YH4-LQKnP5oYrTdXSjLPqIaWVin2KLVDLUgxCGIvBHVWE',
    alt: 'yellow and white adhesive sticky notes arranged on a laptop lid with professional desk setting',
  },
  {
    name: 'Kalendáře',
    detailPath: '/kalendare',
    description: 'Nástěnné, na stůl i plánovací. Celoroční prezentace vaší značky u klienta.',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBAqlxHtlmvaHbPvi1Fnb_ODbx4QBidlZDOLdDki3JGC0fN6ki6vJ3b8Rq4iuUc0uolS0EjFAVuPjmDVjEueemd68Zvsf7bklDkSS7wpjdcOl6Ns8b6atI9Vw3EEOiBUY9ca-86e63GoPiOf1P9EY8d0M1ESvgoO2ImIE-llYFTGXtZd28ckFxxAj9atmE3hdy4X5o8NDAfj1WF56J-ZniFzuEIddS-tJ1xSs49v1X4crbApwZas2Y18fFZoIrd6JZZGm2r73CFWTU',
    alt: 'minimalist wall calendar with large typography and architectural imagery on a concrete wall',
  },
  {
    name: 'Pivní tácky',
    detailPath: '/pivni-tacky',
    description: 'Pivní tácky s kvalitním potiskem. Nasákavá lepenka a perfektní grafika.',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBJqUGJ0N5e0eoB-XOWPzAdN6Lf0n1-x3x4X07wXf_y6Otwud20fsJS2Rw8ujqa0qQHoGRCJ9MlSzdNeFOxo_4XmKiuOuam3sMjyD54o_wPix4PzNZ5Ycjj-wlTOrQFTHfdaIw8TE_HgtC6M4Ks3EndHEN-8DQSQxsQvMYMEaSSi1NOiAtBhrGjQK6su89K6zLru-6BLY1TLqNKqFBDMt8JefeS7pKaYoKNi8sx-GyNsUPG3a2uCCY6LCRJHNI7Sn_-X_D3nMgJ2u8',
    alt: 'round beer coasters with graphic logo design stacked on a dark wooden pub table',
  },
  {
    name: 'Reklamní desky',
    detailPath: '/reklamni-desky',
    description: 'Plastové i papírové reklamní desky pro výstavy i označení provozoven.',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuABeEkZpyas5yy6XXVdX70lOIAbqamCQEq-ULKxjaepewFR3wPX2kML1D7T5jWLZqZx25Tb6Di25hfxcCT76WKRbw8J-nN96LD4mgQpxl5LFrkH07rTuuuxVGOTK505edWp1mjqDu1qt9clN405rZTJqYGJNkTo29PUKBz0bQunA1h__b6RFK8Z5QryLfpoj10-FWHa3yd6To7L1yxWCbh_SLIG_Dsb5M2AtftYzTpMynd4PVXKuVvVTyr-xpgGr4Zo55gSSCwwePU',
    alt: 'rigid architectural display boards with technical drawings in a bright studio environment',
  },
  {
    name: 'Řezaná reklama',
    detailPath: '/rezana-reklama',
    description: 'Plotrované samolepky pro polep výloh a aut z kvalitních sedmiletých fólií.',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAPRK1P00yH0jRO1jt_RjszJ_qFk-NyS4wuHxwQNrtMES8Oa2lB5hhcwiFyMBs5HpCGvwdRSEIRD9tqG7xMesmSiX1nUpDlMD3bCaChYWZFI8PTwPVL_WDdFuR3ZJh1cPWRYbhRi0sORQALav0bGXdRiRjbe4n_z6YVhHoxd9fg1bBplfTH54ecb6LlFGxekMKMvR96FyJxvQz2yD5QjuXK4v307JkQmo74iineLj5-mUiNdcpar8T0l-JpJnizM5b1nFnwLEw836E',
    alt: 'close-up of plotter cut vinyl lettering being applied to a glass window with precision',
  },
  {
    name: 'Prezentační stěny',
    detailPath: '/prezentacni-steny',
    description: 'Od rollupu po skládací prezentační infostěny pro vaše eventy a veletrhy.',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBwadKmki42Ur81n9GndQ2Hkj2TNDBP6lcrscyOJM4VCwkBru90L4oxwuySF03jIQFPx3D95u9r7RLJ4rQfv2L7rEunJdDxWh0SvDhI7KPKYAk6R0PJCaBPM22vbL0YWo1k5Xj0RYtJhQPaYXPDFNEiRYHIQ1zt9IKJ-hLV46tEOcbtDJ3iCEVOU2rzNNnXQ9rBnkZsXQrdxeEiINIo2fntLK89tU1-MKCtxjoGvkdqO6brRqPoSqg_P_WXxIVpF3FWpNZJQ5sfoss',
    alt: 'sleek modern rollup banner stand in a high-tech office lobby with soft architectural light',
  },
  {
    name: 'Tapety',
    detailPath: '/tapety',
    description: 'Vytvořte si tapety s vlastním designem pro unikátní firemní nebo bytový interiér.',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAhhXix9nrFGF0APIy7OFY46sgBQQ_ScQRCr_o5NlPhbGdrvZPAHi0Qu1zP5vBTbW6Z3ZbYY_SftMs00FGa74wHgkyvuCqTezugDb4xM_C5mI0sm3HcC6erGZV1g4Ii5bazb0Bt3WKwrC28-r7fmG48ufEJHD_WjEMtgBf6UNynBbZWoiXuSIVDh7fpEu8wD-HprpxtjLzEsg7DOzX2gyTieqq1cxJvHbB1gB0lJClveaDsveqNBq_v00Qkqb6LGhrleCVImgifF4w',
    alt: 'interior room with custom geometric wallpaper design in muted earth tones and modern furniture',
  },
  {
    name: 'Tisk na plátno',
    detailPath: '/tisk-na-platno',
    description: 'Tisk vašich motivů na malířské plátno natažené na dřevěném rámu.',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAH2-8NCV8ZyT2hzUneBNnVwMp2KIBmdS-gBO-YkslQrgK3HdrAw04S9Y_2iI524ULp0GrUOBOk-KbgFMJfcCXfLJZKcU7LWSno3MF6r4_lqZzxHSJ2dS-XEsuYdWMgoE5Lz8RVb4YT4mQu8dCU_Zyi9ujXWDIEQ7W5MSC4Av1gVkTshQJ0Kx4KOYiHaPs0_HI-UIswBmb6PktZAi_Fd7aj5vozzeTdHSlsuDenXtj03_g0-bKVFFCXx42umg10oQoRakhZyCOVWgk',
    alt: 'fine art canvas print on a wooden easel in a sunlit artist studio with artistic paint splatters',
  },
  {
    name: 'Vizitky',
    detailPath: '/vizitky',
    description: 'Klasické vizitky na křídové i speciální grafické papíry s možností laminace.',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuApzwa28Q0y2f0Uv9y8h5z88iOuyuW3_CEiM7lO075-A7BrGwrHa9AvEL3tWMFxBx18HfIfV-Wk8GVWC6oxWCE7uOs10GLEXPJRnEN_u0LL6Oq61WGZAy8042W_MFFHnug6V3bYUv0W_yAAdCdhgsJpbWgh7Y7YLTEUoDg37Ln_a3jWh3GmDY3f2dE4RfYUG4I4Ikusw0M5ALEO2mKvBLHsCKm4D3yePZrpHXKr8Tdwmfn7qwFRhQzrNQGWgayn5IM-9qQnHcWIXTc',
    alt: 'stack of minimalist luxury business cards with thick paper and indigo blue edge painting',
  },
  {
    name: 'Vlajky',
    detailPath: '/vlajky',
    description: 'Vysoce kvalitní materiály a UV tisk pro vlajky a muší křídla všech velikostí.',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDM7lAbKuJcbG7WE8G_NbOosz3MSH5g1XcUStKsGffJKwmgTQY_jppC2rK4osIMk35IBmH-nNGPebxAuK3lj73a_3HfBPNlANdfAjXbncctZkhIQAnlAIErAghYeavhJXKCwtGOnuDmDjN85WNJtnnY1KgjN5AZEzJvR7FePctConzPRgyJ1rS8Frg1I4x9E-7sbrzDhAbGHYHbU7tAqsQLnjLKtNFE9bIVVSn6Hp11DnZKBeObmKuUdwVFc0bjvLak7rpValdGxW4',
    alt: 'corporate flags waving in the wind in front of a modern glass office building during daytime',
  },
  {
    name: 'Vstupenky',
    detailPath: '/vstupenky',
    description: 'Tisk vstupenek pro vaši akci s číslováním, perforací a ochrannými prvky.',
    src: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBx2AKU2xXw3osg4T00JYBSzMNM0pigbbBSw5EmJi5HcRl3Rl-nSHS9-W9YWWYufvUDuoVLdpzNxpxZaByquUgmvNr9pB6xmyHkgqro7IHh6bttnbLGiSkS14nBfUVxXcsFgGoNtJSoYwm61KTm_5r6j2atT-Abx7lWaAp7rILaM-l8fRtwoApJHC9gtr6uou1S0VRt6fxFmo3UqgsctHLRpQVD27Z9z6RSPRq4n6YqgJkpJZHUFwwW3yKfsmQUfOzgi4KRd-5bJh0',
    alt: 'printed event tickets with perforation and holographic security strips on a minimalist grey background',
  },
  {
    name: '3D plastické nápisy',
    detailPath: '/3d-napisy',
    description: 'Trojrozměrné nápisy a loga.',
    src: require('../images/3D_plasticke_pismo.avif'),
    alt: '3D plastické nápisy a loga na míru',
  },
];

function Katalog() {
  return (
    <>
      <SeoHead page="katalog" />
      <main className="pt-32 pb-16 px-6 md:px-32 bg-background">
        {/* Title Section */}
        <div className="max-w-screen-2xl mx-auto flex flex-col md:flex-row justify-between items-end mb-16 gap-8">
          <div className="max-w-3xl">
            <span className="section-label text-primary font-label tracking-[0.3em]">
              Archiv Preciznosti
            </span>
            <h1 className="text-6xl md:text-8xl font-extrabold tracking-tighter leading-none text-on-surface">
              Tiskoviny<br />na míru
            </h1>
          </div>
          <div className="text-on-surface-variant font-body text-lg leading-relaxed max-w-md pb-2">
            Kurátorovaný výběr tiskových řešení, kde se moderní technologie setkávají s hmatatelnou krásou papíru.
          </div>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-0.5 bg-surface-variant border border-surface-variant">
          {products.map((product) => (
            <div key={product.name} className="product-card group">
              <div className="aspect-[4/5] overflow-hidden relative">
                <img className="product-card-img" src={product.src} alt={product.alt} />
                <div className="product-card-overlay">
                  <Link to="/poptavka" className="btn-ghost-white px-4 py-2">Získat kalkulaci</Link>
                </div>
              </div>
              <div className="product-card-body">
                <h3 className="product-card-title">{product.name}</h3>
                <p className="product-card-desc">{product.description}</p>
                <div className="product-card-footer">
                  {product.detailPath
                    ? <Link to={product.detailPath} className="product-detail-link">Detail produktu</Link>
                    : <a className="product-detail-link" href="#">Detail produktu</a>
                  }
                  <span className="material-symbols-outlined text-outline">arrow_outward</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* Bottom Action Area */}
      <section className="py-24 bg-surface-container-low px-32">
        <div className="max-w-screen-2xl mx-auto flex flex-col items-center text-center">
          <h2 className="text-4xl md:text-5xl font-black tracking-tighter mb-8 max-w-2xl">
            Nenašli jste přesně to, co hledáte?
          </h2>
          <p className="text-on-surface-variant text-lg mb-12 max-w-xl">
            Naše tiskárna nabízí i zakázkovou výrobu na míru. Kontaktujte nás pro individuální kalkulaci vašeho projektu.
          </p>
          <Link to="/poptavka" className="precision-gradient text-white px-12 py-5 text-sm font-bold tracking-[0.2em] uppercase active:scale-95 transition-transform">
            Individuální Poptávka
          </Link>
        </div>
      </section>
      <MobileBottomNav />
    </>
  );
}

export default Katalog;
